// Tremor ProgressBar [v1.0.0]

import { cx } from '@/lib/utils'

interface ProgressBarProps {
  value: number
  className?: string
  color?: 'primary' | 'green'
  // Adds a looping shimmer sweep across the fill, signalling it's actively updating rather than
  // stalled (e.g. a render/upload still in progress). Off by default — existing callers (modals
  // showing a one-shot upload progress) don't opt in automatically.
  active?: boolean
}

const FILL_COLORS: Record<NonNullable<ProgressBarProps['color']>, string> = {
  primary: 'bg-primary-500',
  green: 'bg-green-500',
}

export function ProgressBar({ value, className, color = 'primary', active = false }: ProgressBarProps) {
  const safeValue = Math.min(100, Math.max(0, value))
  return (
    <div className={cx('h-2 w-full rounded-full bg-gray-200', className)}>
      <div
        className={cx('relative h-full overflow-hidden rounded-full transition-all', FILL_COLORS[color])}
        style={{ width: `${safeValue}%` }}
        role="progressbar"
        aria-valuenow={safeValue}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        {active && (
          <div className="progress-bar-shimmer absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent" />
        )}
      </div>
    </div>
  )
}
